import { MINUTES_PER_DAY } from './minutes-per-day';

/** Milliseconds in a 24-hour day. */
export const MILLISECONDS_PER_DAY = MINUTES_PER_DAY * 60 * 1000;
